import { capitalize } from 'lodash'
import { Badge } from '../Badge'

export function PatientStatusBadge({ status }: { status?: string }) {
  if (!status || `nonpatient`.includes(status.toLowerCase())) return null

  const isActive = `active`.includes(status.toLowerCase())
  return <Badge label={capitalize(status)} color={isActive ? `green` : `gray`} />
}
